import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { Award } from '@interfaces';
import { AppService } from '../../../../../../services';


export function getColumns(util: UtilityService, app: AppService) {

	const columns: GridColumn<Award, unknown>[] = [
		buildColumn(util, 'Id', row => row.awardId, { header: 'awardId' }),
		buildColumn(util, 'Text', row => row.name, { header: 'Name' }),
		// buildColumn(util, 'FullName', row => app.getStaffNameById(row.facilitatorId), { header: 'Program Facilitator Name' }),
		// buildColumn(util, 'Text', row => row.languageId === LanguageId.English ? 'English' : 'Spanish', { header: 'Language' }),
		// buildColumn(util, 'Id', row => row.courseVersionId, { header: 'courseVersionId', hidden: true }),
		// buildColumn(util, 'Number', row => row.version, { header: 'Version' }),
		// buildColumn(util, 'Text', row => row.title, { header: 'Title' }),
		// buildColumn(util, 'YesNo', row => row.latestVersion, { header: 'Latest Version', hidden: true }),
		// buildColumn(util, 'Number', row => row.entrepreneurs, { header: 'Entrepreneurs' }),
		// buildColumn(util, 'Number', row => row.enrolled, { header: 'Enrolled' }),
		// buildColumn(util, 'Number', row => row.notEnrolled, { header: 'Not Enrolled', hidden: true }),
		// buildColumn(util, 'Text', row => row.meetingLocalDisplayText, { header: 'Meeting Time (local time)', headerTooltip: 'Time is shown in the time zone of your current location' }),
		// buildColumn(util, 'Text', row => row.meetingAcceleratorDisplayText, { header: 'Meeting Time (accelerator time)', headerTooltip: 'Time is shown in the time zone of the accelerator', hidden: true }),
		// buildColumn(util, 'Text', row => row.gravityLocation, { header: 'Gravity Location' }),
		// buildColumn(util, 'Text', row => row.gravityZip.toString().padStart(5, '0'), { header: 'Gravity Zip' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated', hidden: true }),
	];


	return columns;

}
